(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8160],{

/***/ 44174:
/***/ (function(module) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ 81119:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 55189:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(44174),
    baseAggregator = __webpack_require__(81119),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ 24350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    createAggregator = __webpack_require__(55189);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),

/***/ 66604:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    baseForOwn = __webpack_require__(47816),
    baseIteratee = __webpack_require__(67206);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 95472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22638);
/* harmony import */ var client_services_hubspot_service_contact_form_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49228);


/* harmony default export */ __webpack_exports__["Z"] = ({
    portalId: "5945317",
    formId: client_services_hubspot_service_contact_form_config__WEBPACK_IMPORTED_MODULE_1__/* .CONTACT_SALES_HUBSPOT_FORM_ID */ .PD,
    source: client_services_hubspot_service_hubspot_constants__WEBPACK_IMPORTED_MODULE_0__/* .leadSourceDefaultValue */ .Ts,
    withPrivacyNotice: true
});


/***/ }),

/***/ 78160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hubspot_contact_form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-service.js
var hubspot_service = __webpack_require__(23155);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/sales/campaigns.js
var campaigns = __webpack_require__(44363);
// EXTERNAL MODULE: ./segments/desktop/core-components/base-form/base-form.js + 5 modules
var base_form = __webpack_require__(17784);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./client/services/exceptions-handling-service/exceptions-handling-service.js
var exceptions_handling_service = __webpack_require__(53989);
// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
// EXTERNAL MODULE: ./client/services/form-service/form-inputs.js + 18 modules
var form_inputs = __webpack_require__(5893);
// EXTERNAL MODULE: ./client/services/form-service/form-service.js
var form_service = __webpack_require__(25887);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
// EXTERNAL MODULE: ./node_modules/lodash/keyBy.js
var keyBy = __webpack_require__(24350);
var keyBy_default = /*#__PURE__*/__webpack_require__.n(keyBy);
// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(66604);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/default-props.js
var default_props = __webpack_require__(95472);
;// CONCATENATED MODULE: ./segments/desktop/core-components/hubspot-contact-form/consts.js
var HUBSPOT_TO_LEAD_DATA_MAP = {
    first_name: "firstname",
    last_name: "lastname",
    email: "email",
    job_title: "jobtitle",
    phone: "phone",
    company_name: "company",
    company_size: "company_size__c",
    product: "product_question_hs_forms"
};

;// CONCATENATED MODULE: ./segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form.js







function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






















var HUBSPOT_INVALID_EMAIL_ERROR_TYPE = "INVALID_EMAIL";
var GARTNER_REPORT_URL = "https://www.gartner.com/doc/reprints?id=1-2AKZAKIR&ct=220714&st=sb";
var HubspotContactForm = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HubspotContactForm, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HubspotContactForm);
    function HubspotContactForm(props) {
        (0,_class_call_check/* default */.Z)(this, HubspotContactForm);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getFirstErrorMessageFromResponse", function(response) {
            var _response_errors_, _response_errors, _response_errors_1, _response_errors1;
            if ((response === null || response === void 0 ? void 0 : (_response_errors = response.errors) === null || _response_errors === void 0 ? void 0 : (_response_errors_ = _response_errors[0]) === null || _response_errors_ === void 0 ? void 0 : _response_errors_.errorType) === HUBSPOT_INVALID_EMAIL_ERROR_TYPE) {
                // Formatting Hubspot message into more user friendly one for known message types
                return "form.errors.invalidEmailError";
            }
            return response === null || response === void 0 ? void 0 : (_response_errors1 = response.errors) === null || _response_errors1 === void 0 ? void 0 : (_response_errors_1 = _response_errors1[0]) === null || _response_errors_1 === void 0 ? void 0 : _response_errors_1.message;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "convertValuesToHubspotFormat", function(formData) {
            var _props = _this.props, withPrivacyNotice = _props.withPrivacyNotice, formId = _props.formId, overrideCampaignId = _props.overrideCampaignId, formTitle = _props.formTitle, lastNameFirst = _props.lastNameFirst;
            var formConfig = (0,contact_form_config/* getContactFormConfigById */.Ty)({
                formId: formId,
                overrideCampaignId: overrideCampaignId,
                withPrivacyNotice: withPrivacyNotice,
                formTitle: formTitle,
                lastNameFirst: lastNameFirst
            });
            var convertedData = [];
            formData.forEach(function(inputField) {
                var inputConfig = (0,form_service/* getInputDataByName */.au)(formConfig, inputField.name);
                if (inputConfig.type === form_inputs/* inputTypes.MULTI_SELECT */.Je.MULTI_SELECT) {
                    if (Array.isArray(inputField.value)) {
                        convertedData.push({
                            name: inputField.name,
                            value: inputField.value.map(function(option) {
                                return option.value;
                            }).join(";")
                        });
                    } else {
                        convertedData.push({
                            name: inputField.name,
                            value: inputField.value.value
                        });
                    }
                } else {
                    convertedData.push(inputField);
                }
            });
            return convertedData;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "convertToLeadData", function(convertedFormData) {
            var leadData = {};
            Object.keys(HUBSPOT_TO_LEAD_DATA_MAP).forEach(function(key) {
                var hubspotKey = HUBSPOT_TO_LEAD_DATA_MAP[key];
                var field = convertedFormData.find(function(item) {
                    return item.name === hubspotKey;
                });
                if (field) {
                    leadData[key] = field.value;
                }
            });
            return leadData;
        });
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "sendFormToHubspot", function() {
            var _ref = _async_to_generator(function(formData) {
                var _fields_find, _props, formId, portalId, abTests, cookies, isV13PricingVersion, withPrivacyNotice, source, overrideCampaignId, cloudfrontViewerCountry, hiddenDataParams, convertedData, fields, _fields_find_value, companySizeValue, response, success, errorMessage, _response_errors_, firstErrorType, data, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                4
                            ]);
                            _props = _this1.props, formId = _props.formId, portalId = _props.portalId, abTests = _props.abTests, cookies = _props.cookies, isV13PricingVersion = _props.isV13PricingVersion, withPrivacyNotice = _props.withPrivacyNotice, source = _props.source, overrideCampaignId = _props.overrideCampaignId, cloudfrontViewerCountry = _props.cloudfrontViewerCountry;
                            hiddenDataParams = (0,hubspot_service/* generateHiddenData */.OB)({
                                withPrivacyNotice: withPrivacyNotice,
                                source: source,
                                overrideCampaignId: overrideCampaignId,
                                cookies: cookies,
                                cloudfrontViewerCountry: cloudfrontViewerCountry
                            });
                            convertedData = _this1.convertValuesToHubspotFormat(formData);
                            fields = (0,_to_consumable_array/* default */.Z)(convertedData).concat((0,_to_consumable_array/* default */.Z)(hiddenDataParams));
                            companySizeValue = (_fields_find_value = (_fields_find = fields.find(function(item) {
                                return item.name === hubspot_constants/* HUBSPOT_API_COMPANY_SIZE */.h4;
                            })) === null || _fields_find === void 0 ? void 0 : _fields_find.value) !== null && _fields_find_value !== void 0 ? _fields_find_value : null;
                            return [
                                4,
                                (0,hubspot_service/* sendHubspotForm */.Pw)(portalId, formId, fields)
                            ];
                        case 1:
                            response = _state.sent();
                            success = response && !response.status; // Success request has no status entry
                            errorMessage = null;
                            if (!success) {
                                ;
                                firstErrorType = (response === null || response === void 0 ? void 0 : response.errors) && (response === null || response === void 0 ? void 0 : (_response_errors_ = response.errors[0]) === null || _response_errors_ === void 0 ? void 0 : _response_errors_.errorType);
                                errorMessage = _this1.getFirstErrorMessageFromResponse(response);
                                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_SUBMIT_FAILED, {
                                    kind: formId,
                                    info1: firstErrorType,
                                    info2: errorMessage
                                });
                            } else {
                                ;
                                try {
                                    data = _object_spread_props(_object_spread({}, mapValues_default()(keyBy_default()(fields, "name"), "value")), {
                                        leadsource: source
                                    });
                                } catch (e1) {
                                    esm_exports/* captureException */.Tb(e1);
                                }
                                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_SUBMIT_CLICKED, {
                                    kind: formId,
                                    info1: companySizeValue,
                                    data: data
                                });
                                (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).HUBSPOT_FORM_SUBMITTED, {
                                    formId: formId,
                                    lead_data: _this1.convertToLeadData(convertedData)
                                });
                            }
                            (0,monetization_ab_tests_service/* enterV13TestIfNeeded */.p)(abTests, cookies, undefined, isV13PricingVersion);
                            return [
                                2,
                                {
                                    success: success,
                                    errorMessage: errorMessage
                                }
                            ];
                        case 2:
                            e = _state.sent();
                            return [
                                4,
                                (0,exceptions_handling_service/* handleClientException */.N)({
                                    e: e,
                                    bbEventParams: {
                                        name: bigbrain_event_types.CONTACT_SALES_FORM_SUBMISSION_FAILED
                                    }
                                })
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(formData) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getSubmitScreenData", function() {
            var overrideCampaignId = _this.props.overrideCampaignId;
            switch(overrideCampaignId){
                case campaigns/* IPO_CAMPAIGN_ID */.Q:
                    return {
                        titleKey: "forms.thanksPage.ipoCampaign.title",
                        subTitleHtmlKey: "forms.thanksPage.ipoCampaign.subTitleHtml"
                    };
                case campaigns/* GARTNER_CAMPAIGN_ID */.S:
                    return {
                        titleKey: "forms.thanksPage.gartnerCampaign.title",
                        subTitleHtmlKey: "forms.thanksPage.gartnerCampaign.subTitleHtml2023",
                        footerHtml: "forms.thanksPage.gartnerCampaign.footerHtml",
                        downloadButtonLink: GARTNER_REPORT_URL
                    };
                default:
                    return null;
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onInputBlur", function(name, value) {
            var formId = _this.props.formId;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_INPUT_BLUR, {
                kind: formId,
                info1: name,
                info2: value === null || value === void 0 ? void 0 : value.length
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "handleFirstFormSubmit", function() {
            _this.setState({
                firstFormSubmitted: true
            });
        });
        _this.state = {
            firstFormSubmitted: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(HubspotContactForm, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var formId = this.props.formId;
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.HUBSPOT_FORM_READY, {
                    kind: formId
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, withPrivacyNotice = _props.withPrivacyNotice, formId = _props.formId, overrideCampaignId = _props.overrideCampaignId, backgroundLayers = _props.backgroundLayers, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser, formTitle = _props.formTitle, lastNameFirst = _props.lastNameFirst, formSubTitle = _props.formSubTitle, urlToRedirectAfterSubmission = _props.urlToRedirectAfterSubmission, isV2 = _props.isV2, dontRenderPostFormSubmit = _props.dontRenderPostFormSubmit, splitForm = _props.splitForm, restProps = _props.restProps;
                var firstFormSubmitted = this.state.firstFormSubmitted;
                var formConfig = (0,contact_form_config/* getContactFormConfigById */.Ty)({
                    formId: formId,
                    overrideCampaignId: overrideCampaignId,
                    withPrivacyNotice: withPrivacyNotice,
                    formTitle: formTitle,
                    lastNameFirst: lastNameFirst,
                    isV2: isV2,
                    splitForm: splitForm,
                    firstFormSubmitted: firstFormSubmitted
                });
                var submitScreenData = this.getSubmitScreenData();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hubspot-contact-form-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_form/* default */.Z, {
                        backgroundLayers: isMobileOrTabletBrowser ? 0 : backgroundLayers,
                        formConfig: formConfig,
                        submitFormAsyncCallback: this.sendFormToHubspot,
                        submitScreenData: submitScreenData,
                        onInputBlur: this.onInputBlur,
                        renderPrivacyNotice: withPrivacyNotice,
                        urlToRedirectAfterSubmission: urlToRedirectAfterSubmission,
                        dontRenderPostFormSubmit: dontRenderPostFormSubmit,
                        isV2: isV2,
                        handleFirstFormSubmit: this.handleFirstFormSubmit,
                        splitForm: splitForm,
                        firstFormSubmitted: firstFormSubmitted,
                        restProps: restProps,
                        formSubTitle: formSubTitle
                    })
                });
            }
        }
    ]);
    return HubspotContactForm;
}(react.PureComponent);
HubspotContactForm.defaultProps = default_props/* default */.Z;
/* harmony default export */ var hubspot_contact_form = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(HubspotContactForm)));


/***/ })

}]);